import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=130149a7&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130149a7",
  null
  
)

export default component.exports